import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Reports.css"; // Ensure the CSS file is properly linked

const Reports = () => {
  // Placeholder for report links or data fetching logic
  const navigate = useNavigate();

  // Function to handle navigation
  const handleNavigate = (path) => {
    navigate(path);
  };

  useEffect(() => {
    console.log(process.env);
  }, []);

  return (
    <div className="reports-container">
      <h1>Reports</h1>
      <div
        className="report-card"
        onClick={() => handleNavigate("/reports/not-ordered-this-month")}
      >
        Customers who have NOT given order this month (
        {process.env.REACT_APP_CURRENT_MONTH})
      </div>
      <div
        className="report-card"
        onClick={() => handleNavigate("/reports/less-ordered-this-month")}
      >
        Customers who have given LESS Order this Month (
        {process.env.REACT_APP_CURRENT_MONTH})
      </div>
      <div
        className="report-card"
        onClick={() => handleNavigate("/reports/not-ordered-two-months")}
      >
        Customers who have NOT given order both in month of (
        {process.env.REACT_APP_LAST_MONTH} &{" "}
        {process.env.REACT_APP_CURRENT_MONTH})
      </div>
      <div
        className="report-card"
        onClick={() => handleNavigate("/reports/missing-yearly-targets")}
      >
        Customers who are going to MISS their YEARLY targets
      </div>
      <div
        className="report-card"
        onClick={() => handleNavigate("/reports/missing-monthly-targets")}
      >
        Customers who are going to MISS their MONTHLY targets (
        {process.env.REACT_APP_CURRENT_MONTH})
      </div>
      <div
        className="report-card"
        onClick={() => handleNavigate("/reports/item-wise-reports")}
      >
        Item Wise Reports
      </div>
      <div
        className="report-card"
        onClick={() => handleNavigate("/reports/my-all-parties")}
      >
        My All Parties
      </div>
      {/* Add more report links or dynamic content as needed */}
    </div>
  );
};

export default Reports;
